export class UserProfilePictureCommand {
    formData: FormData;

    constructor(file: File, fileName: string = file.name) {
        this.formData = new FormData();

        this.formData.append('profile_picture', file, fileName);
    }
}
